import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
// import Paper from '@material-ui/core/Paper';
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { CommonReducerAction, ExtraTimeData } from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../Component/InputValues";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {
    // padding: theme.spacing.unit * 3,
  },
});

class ExtraTimePolicy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isetapprovalrequired: false,
      isseparatebalance: false,
      ispastdateallowed: false,
      ispayableapproverequired: false,
      iscompoffapproverequired: false,
      lapsetypeid: null,
      lapsedays: 0,
      isattachment: false,
      attachLimit: false,
      attachmentdurationlimit: 0,
      attachmentnote: "",
      allowedhalfday: false,
      maxleave: 0,
      maxdurationtypeid: null,
      consecutiveleave: 0,
      consecutivedurationtypeid: null,
      maxConseCheck: false,
      maxleaveCheck: false,
      applicationmadeid: null,
      maxdayduration: 0,
      maxdays: 0,
      mindayduration: 0,
      mindays: 0,
      pastdays: 0,
      pastdayduration: 0,
      workingBenefitId: 0,
      nonWorkingBenefitId: 0,
      isfurtureappallowed: false,
      minleavecountforapp: 0,
      notifyinadvanceday: 0,
      notifynotbeforeday: 0,
      ispastappallowed: false,
      apppastday: 0,
      error: [false, false, false, false, false],
      durationSlab: [
        { displayname: "Month", displayvalue: 1 },
        { displayname: "Quarter", displayvalue: 2 },
      ],
    };

    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  validateNext = () => {
    if (
      this.state.workingBenefitId == 2
      || this.state.nonWorkingBenefitId == 2
    ) {
      const error = [false, false, false];
      if (this.state.lapsetypeid < 1) {
        error[0] = true;
        this.props.StepError(4, true);
      } else if (this.state.lapsedays == 0 && this.state.lapsetypeid == 1) {
        error[1] = true;
        this.props.StepError(4, true);
      } else if (
        this.state.maxleaveCheck
        && (this.state.maxleave == 0 || this.state.maxdurationtypeid == null)
      ) {
        error[2] = true;
        this.props.StepError(4, true);
      } else if (
        this.state.maxConseCheck
        && (this.state.consecutiveleave == 0
          || this.state.consecutivedurationtypeid == null)
      ) {
        error[2] = true;
        this.props.StepError(4, true);
      } else if (
        this.state.isfurtureappallowed
        && (this.state.minleavecountforapp == 0
          || this.state.notifyinadvanceday == 0
          || this.state.notifynotbeforeday == 0)
      ) {
        error[3] = true;
        this.props.StepError(4, true);
      } else if (this.state.ispastappallowed && this.state.apppastday == 0) {
        error[4] = true;
        this.props.StepError(4, true);
      } else if (
        this.state.isfurtureappallowed
        && this.state.notifyinadvanceday > this.state.notifynotbeforeday
      ) {
        error[3] = true;
        this.props.StepError(4, true);
      } else {
        this.props.click();
        this.props.StepError(4, false);
      }
      this.setState({ error });
    } else {
      this.props.click();
      this.props.StepError(4, false);
    }
  }

  componentDidMount() {
    // this.getDurationSlab()
    window.addEventListener("beforeunload", this.onBeforeUpload);

    this.props.onRef({
      onNext: this.validateNext,
    });

    const { extraTimeDataReducer } = this.props;
    const extraTimeDataReducerPolicy = extraTimeDataReducer.extratimecompoffpolicy[0];
    this.setState(
      {
        isetapprovalrequired: extraTimeDataReducer.isetapprovalrequired,
        isseparatebalance: extraTimeDataReducer.isseparatebalance,
        ispayableapproverequired: extraTimeDataReducer.ispayableapproverequired,
        iscompoffapproverequired: extraTimeDataReducer.iscompoffapproverequired,
        ispastdateallowed: extraTimeDataReducer.ispastdateallowed,
        lapsedays: extraTimeDataReducerPolicy.lapsedays,
        lapsetypeid: extraTimeDataReducerPolicy.lapsetypeid,
        isattachment: extraTimeDataReducerPolicy.isattachment,
        attachmentdurationlimit:
          extraTimeDataReducerPolicy.attachmentdurationlimit,
        attachmentnote: extraTimeDataReducerPolicy.attachmentnote,
        maxleave: extraTimeDataReducerPolicy.maxleave,
        maxdurationtypeid:
          extraTimeDataReducerPolicy.maxdurationtypeid > 0
            ? this.state.durationSlab.find(
                (x) =>
                  x.displayvalue
                  == extraTimeDataReducerPolicy.maxdurationtypeid,
              )
            : null,
        consecutivedurationtypeid:
          extraTimeDataReducerPolicy.consecutivedurationtypeid > 0
            ? this.state.durationSlab.find(
                (x) =>
                  x.displayvalue
                  == extraTimeDataReducerPolicy.consecutivedurationtypeid,
              )
            : null,
        consecutiveleave: extraTimeDataReducerPolicy.consecutiveleave,
        // mindayduration: extraTimeDataReducerPolicy.mindayduration,
        // mindays: extraTimeDataReducerPolicy.mindays,
        // maxdayduration: extraTimeDataReducerPolicy.maxdayduration,
        // maxdays: extraTimeDataReducerPolicy.maxdays,
        // pastdayduration: extraTimeDataReducerPolicy.pastdayduration,
        // pastdays: extraTimeDataReducerPolicy.pastdays,
        // applicationmadeid: extraTimeDataReducerPolicy.applicationmadeid,
        isfurtureappallowed: extraTimeDataReducerPolicy.isfurtureappallowed,
        minleavecountforapp: extraTimeDataReducerPolicy.minleavecountforapp,
        notifyinadvanceday: extraTimeDataReducerPolicy.notifyinadvanceday,
        notifynotbeforeday: extraTimeDataReducerPolicy.notifynotbeforeday,
        ispastappallowed: extraTimeDataReducerPolicy.ispastappallowed,
        apppastday: extraTimeDataReducerPolicy.apppastday,
        workingBenefitId: extraTimeDataReducer.extratime[0].benefittypeid,
        nonWorkingBenefitId: extraTimeDataReducer.extratime[1].benefittypeid,
        allowedhalfday: extraTimeDataReducerPolicy.allowedhalfday,
      },
      () => {
        // if (this.state.attachmentdurationlimit != 0) {
        //     this.setState({ attachLimit: true })
        // }
        // if (this.state.attachmentnote.length > 0) {
        //     this.setState({ comment: true })
        // }
        if (
          this.state.maxleave > 0
          && extraTimeDataReducerPolicy.maxdurationtypeid > 0
        ) {
          this.setState({ maxleaveCheck: true });
        }
        if (
          this.state.consecutiveleave > 0
          && extraTimeDataReducerPolicy.consecutivedurationtypeid > 0
        ) {
          this.setState({ maxConseCheck: true });
        }
      },
    );
  }

  // getDurationSlab() {
  //     instance.get(`/superuser/getmastercode/DurationSlab`).then((result) => {
  //         let extraTimeDataReducer = this.props.extraTimeDataReducer
  //         let extraTimeDataReducerPolicy = extraTimeDataReducer.extratimecompoffpolicy[0]
  //         let durationSlab = result.data.result.filter(word => word.displayvalue != 3)
  //         durationSlab = durationSlab.filter(word => word.displayvalue != 4)
  //         this.setState({
  //             durationSlab,
  //             maxdurationtypeid: extraTimeDataReducerPolicy.maxdurationtypeid > 0 ? result.data.result.find(x => x.displayvalue == extraTimeDataReducerPolicy.maxdurationtypeid) : null,
  //             consecutivedurationtypeid: extraTimeDataReducerPolicy.consecutivedurationtypeid > 0 ? result.data.result.find(x => x.displayvalue == extraTimeDataReducerPolicy.consecutivedurationtypeid) : null,
  //         })
  //     }, (error) => {
  //         let CommonError = error.response
  //             ? error.response.data.error.message
  //             : error.message;
  //         this.props.enqueueSnackbar(CommonError, { variant: 'error' })
  //     })
  // }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(4, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  handleExpandClick01 = () => {
    this.setState(
      {
        isetapprovalrequired: !this.state.isetapprovalrequired,
        ispastdateallowed: false,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.isetapprovalrequired = this.state.isetapprovalrequired;
        extraTimeDataReducer.ispastdateallowed = false;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  handleExpandClick02 = () => {
    this.setState(
      {
        isseparatebalance: !this.state.isseparatebalance,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.isseparatebalance = this.state.isseparatebalance;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  handleExpandClick03 = () => {
    this.setState(
      {
        ispayableapproverequired: !this.state.ispayableapproverequired,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.ispayableapproverequired = this.state.ispayableapproverequired;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  handleExpandClick04 = () => {
    this.setState(
      {
        iscompoffapproverequired: !this.state.iscompoffapproverequired,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.iscompoffapproverequired = this.state.iscompoffapproverequired;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  lapseHandleExpandClick05 = (id) => {
    this.setState(
      {
        lapsetypeid: id,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.extratimecompoffpolicy[0].lapsetypeid = this.state.lapsetypeid;
        if (this.state.lapsetypeid != 1) {
          this.setState({ lapsedays: 0 });
          extraTimeDataReducer.extratimecompoffpolicy[0].lapsedays = 0;
        }

        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  handleExpandClick06 = () => {
    this.setState(
      {
        isattachment: !this.state.isattachment,
        attachmentnote: "",
        attachmentdurationlimit: 0,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.extratimecompoffpolicy[0].isattachment = this.state.isattachment;
        extraTimeDataReducer.extratimecompoffpolicy[0].attachmentdurationlimit = this.state.attachmentdurationlimit;
        extraTimeDataReducer.extratimecompoffpolicy[0].attachmentnote = this.state.attachmentnote;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  leaveLimitHandleExpandClick07(field) {
    this.setState({ [field]: !this.state[field] }, () => {
      const { extraTimeDataReducer } = this.props;
      switch (field) {
        case "maxleaveCheck": {
          this.setState({ maxleave: 0, maxdurationtypeid: null });
          extraTimeDataReducer.extratimecompoffpolicy[0].maxleave = 0;
          extraTimeDataReducer.extratimecompoffpolicy[0].maxdurationtypeid = 0;
          break;
        }
        case "maxConseCheck": {
          this.setState({
            consecutiveleave: 0,
            consecutivedurationtypeid: null,
          });
          extraTimeDataReducer.extratimecompoffpolicy[0].consecutiveleave = 0;
          extraTimeDataReducer.extratimecompoffpolicy[0].consecutivedurationtypeid = 0;
          break;
        }
        default:
          break;
      }
      this.props.ExtraTimeData({ ...extraTimeDataReducer });
    });
  }

  handleExpandClick08 = () => {
    this.setState(
      {
        allowedhalfday: !this.state.allowedhalfday,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.extratimecompoffpolicy[0].allowedhalfday = this.state.allowedhalfday;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  };

  numberOnChange(field, max, event) {
    const numbers = /^[0-9]+$/;
    if (event.target.value.match(numbers)) {
      const { extraTimeDataReducer } = this.props;
      if (
        event.target.value > 0
        && !Number.isNaN(event.target.value)
        && parseInt(event.target.value) <= max
        && max
      ) {
        this.setState({ [field]: Number(event.target.value) }, () => {
          extraTimeDataReducer.extratimecompoffpolicy[0][field] = parseInt(
            this.state[field],
          );
          this.props.ExtraTimeData({ ...extraTimeDataReducer });
        });
      }
    }
  }

  pastDateAppOnChange() {
    this.setState(
      {
        ispastdateallowed: !this.state.ispastdateallowed,
      },
      () => {
        const { extraTimeDataReducer } = this.props;
        extraTimeDataReducer.ispastdateallowed = this.state.ispastdateallowed;
        this.props.ExtraTimeData({ ...extraTimeDataReducer });
      },
    );
  }

  durationSlabOnChange(field, val) {
    this.setState({ [field]: val }, () => {
      const { extraTimeDataReducer } = this.props;
      extraTimeDataReducer.extratimecompoffpolicy[0][field] = val.displayvalue;
      this.props.ExtraTimeData({ ...extraTimeDataReducer });
    });
  }

  // trueFalseOnChange(field) {
  //     this.setState({ [field]: !this.state[field] }, () => {
  //         let extraTimeDataReducer = this.props.extraTimeDataReducer
  //         switch (field) {
  //             case "comment": {
  //                 this.setState({ attachmentnote: "" })
  //                 extraTimeDataReducer.extratimecompoffpolicy[0].attachmentnote = ""
  //             }
  //                 break;
  //             case "attachLimit": {
  //                 this.setState({ attachmentdurationlimit: 0 })
  //                 extraTimeDataReducer.extratimecompoffpolicy[0].attachmentdurationlimit = 0
  //             }
  //                 break;
  //         }
  //         this.props.ExtraTimeData({ ...extraTimeDataReducer })
  //     })
  // }
  onCommentChange(event) {
    this.setState({ attachmentnote: event.target.value }, () => {
      const { extraTimeDataReducer } = this.props;
      extraTimeDataReducer.extratimecompoffpolicy[0].attachmentnote = this.state.attachmentnote;
      this.props.ExtraTimeData({ ...extraTimeDataReducer });
    });
  }

  handleChange(name, ...arg) {
    switch (name) {
      // case "minleavecountforapp":
      // case "notifyinadvanceday":
      // case "notifynotbeforeday":
      // case "apppastday":
      //   this.CommonNumberChange(name, arg);
      //   break;
      case "isfurtureappallowed":
        this.setState(
          {
            [name]: arg[0],
            minleavecountforapp: 0,
            notifyinadvanceday: 0,
            notifynotbeforeday: 0,
          },
          () => {
            const { extraTimeDataReducer } = this.props;
            extraTimeDataReducer.extratimecompoffpolicy[0].isfurtureappallowed = this.state.isfurtureappallowed;
            extraTimeDataReducer.extratimecompoffpolicy[0].minleavecountforapp = this.state.minleavecountforapp;
            extraTimeDataReducer.extratimecompoffpolicy[0].notifyinadvanceday = this.state.notifyinadvanceday;
            extraTimeDataReducer.extratimecompoffpolicy[0].notifynotbeforeday = this.state.notifynotbeforeday;
            this.props.ExtraTimeData({ ...extraTimeDataReducer });
          },
        );
        break;
      case "ispastappallowed":
        this.setState({ [name]: arg[0], apppastday: 0 }, () => {
          const { extraTimeDataReducer } = this.props;
          extraTimeDataReducer.extratimecompoffpolicy[0].ispastappallowed = this.state.ispastappallowed;
          extraTimeDataReducer.extratimecompoffpolicy[0].apppastday = this.state.apppastday;
          this.props.ExtraTimeData({ ...extraTimeDataReducer });
        });
        break;
      default:
        break;
    }
  }

  render() {
    const language = this.props.Language.extratimepolicy;

    return (
      <IntlProvider locale="en" messages={language} className="center">
        <div className="stepper-scroller padding-top-0">
          <div className="padding-bottom-30 stepper-scroller-content">
            <div className="inner-wrapper opaque">
              {/* 1 */}
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbApproval"
                  defaultMessage="Do you want employees to work extra time only on approval? (Employee will not receive extra time benefits if prior approval to work extra time is not taken)"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={this.handleExpandClick01}
                aria-expanded={this.state.isetapprovalrequired}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isetapprovalrequired == true ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              <div className="et-level2">
                <Collapse
                  in={this.state.isetapprovalrequired}
                  timeout={2}
                  unmountOnExit
                  className="padding30 padding-top-10 padding-bottom-10 overflow-initial position-rel"
                >
                  <FormattedMessage
                    id="LbApporovalPastDate"
                    defaultMessage="Allow employees to get past dated extra time approval"
                  />
                  <Checkbox
                    checked={!!this.state.ispastdateallowed}
                    onChange={this.pastDateAppOnChange.bind(this)}
                    value={this.state.ispastdateallowed}
                    color="primary"
                    className="checkbox-click"
                  />
                </Collapse>
              </div>
              <div
                className="depedent-select-list "
                onClick={this.handleExpandClick01}
                aria-expanded={!this.state.isetapprovalrequired}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isetapprovalrequired == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
              {/* 2 */}
              {/* {this.state.workingBenefitId == 2
              && this.state.nonWorkingBenefitId == 2 ? (
                <div>
                  <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="LbLeaveBalance"
                      defaultMessage="Do you want to maintain two separate balance for comp-off leaves earned on working and non-working days?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick02}
                    aria-expanded={this.state.isseparatebalance}
                  >
                    <span>
                      <FormattedMessage id="LbYes" defaultMessage="Yes" />
                    </span>
                    {this.state.isseparatebalance == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.handleExpandClick02}
                    aria-expanded={!this.state.isseparatebalance}
                  >
                    <span>
                      <FormattedMessage id="LbNo" defaultMessage="No" />
                    </span>
                    {this.state.isseparatebalance == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                </div>
              ) : (
                ""
              )} */}
              {/* 3 */}
              {this.state.workingBenefitId == 1
              || this.state.nonWorkingBenefitId == 1 ? (
                <div>
                  <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="LbPayablePermission"
                      defaultMessage="Does crediting payable earning require special permissions?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick03}
                    aria-expanded={this.state.ispayableapproverequired}
                  >
                    <span>
                      <FormattedMessage
                        id="LbYes"
                        defaultMessage="Yes, Follow attendance approval workflow"
                      />
                    </span>
                    {this.state.ispayableapproverequired == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.handleExpandClick03}
                    aria-expanded={!this.state.ispayableapproverequired}
                  >
                    <span>
                      <FormattedMessage
                        id="LbNo"
                        defaultMessage="No, Credit it to employees directly"
                      />
                    </span>
                    {this.state.ispayableapproverequired == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                </div>
              ) : (
                ""
              )}
              {/* 4 */}
              {this.state.workingBenefitId == 2
              || this.state.nonWorkingBenefitId == 2 ? (
                <div>
                  <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="__LbCompOffPermission"
                      defaultMessage="Does crediting comp-off leaves require approval?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick04}
                    aria-expanded={this.state.iscompoffapproverequired}
                  >
                    <span>
                      <FormattedMessage
                        id="LbYes"
                        defaultMessage="Yes, Follow attendance approval workflow"
                      />
                    </span>
                    {this.state.iscompoffapproverequired == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.handleExpandClick04}
                    aria-expanded={!this.state.iscompoffapproverequired}
                  >
                    <span>
                      <FormattedMessage
                        id="LbNo"
                        defaultMessage="No, Credit it to employees directly"
                      />
                    </span>
                    {this.state.iscompoffapproverequired == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>

                  {/* 5 */}
                  <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="LbLapse"
                      defaultMessage="How do we handle unused comp-off balance?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.lapseHandleExpandClick05.bind(this, 1)}
                    aria-expanded={this.state.lapsetypeid == 1}
                  >
                    <span>
                      <FormattedMessage
                        id="__LbLapseAfterComp"
                        defaultMessage="Comp-off will lapse"
                      />
                      <InputValues
                        min="0"
                        max="1096"
                        field="lapsedays"
                        defaultvalue={0}
                        onChange={this.numberOnChange.bind(
                          this,
                          "lapsedays",
                          1096,
                        )}
                        value={this.state.lapsedays}
                      />
                      <span>
                        <FormattedMessage
                          id="___LbLapseAfterComp"
                          defaultMessage=" days after earning"
                        />
                      </span>
                    </span>
                    {this.state.lapsetypeid == 1 ? (
                      <span className="floatright margin-top-10">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected margin-top-10" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.lapseHandleExpandClick05.bind(this, 2)}
                    aria-expanded={this.state.lapsetypeid == 2}
                  >
                    <span>
                      <FormattedMessage
                        id="LbDoesntLapse"
                        defaultMessage="Does not lapse, retain all unused comp-off credit for future use"
                      />
                    </span>
                    {this.state.lapsetypeid == 2 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.lapseHandleExpandClick05.bind(this, 3)}
                    aria-expanded={this.state.lapsetypeid == 3}
                  >
                    <span>
                      <FormattedMessage
                        id="LbLapseAtEnd"
                        defaultMessage="Lapse at the end of Leave Cycle"
                      />
                    </span>
                    {this.state.lapsetypeid == 3 ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  {this.state.error[0] ? (
                    <div className="caption-error">
                      *Please select an option.
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.error[1] ? (
                    <div className="caption-error">
                      *Please select valid value.
                    </div>
                  ) : (
                    ""
                  )}
                  {/* 6 */}
                  <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="LbAttanchment"
                      defaultMessage="Do you want to keep attachments (supporting documents) compulsory when applying the earned comp-off leaves?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick06}
                    aria-expanded={this.state.isattachment}
                  >
                    <span>
                      <FormattedMessage id="LbYes" defaultMessage="Yes" />
                    </span>
                    {this.state.isattachment == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  <div className="et-level2 ">
                    <Collapse
                      in={this.state.isattachment}
                      timeout={2}
                      unmountOnExit
                      className="padding30 padding-top-20 overflow-initial"
                    >
                      <FormattedMessage
                        id="LbLeaveGreaterThan"
                        defaultMessage="Only if leave duration is greater than "
                      />
                      <InputValues
                        min="0"
                        max="30"
                        field="attachmentdurationlimit"
                        onChange={this.numberOnChange.bind(
                          this,
                          "attachmentdurationlimit",
                          30,
                        )}
                        value={this.state.attachmentdurationlimit}
                        defaultvalue={0}
                      />

                      {/* <Checkbox
                                        checked={this.state.attachLimit ? true : false}
                                        onChange={this.trueFalseOnChange.bind(this, "attachLimit")}
                                        value={this.state.attachLimit}
                                        color="primary"
                                        className="checkbox-click"
                                    /> */}
                      <br />
                      <br />
                      <FormattedMessage
                        id="LbAttachmentInstruction"
                        defaultMessage="Feel free to add description text here for any special instructions regarding attachments required?"
                      />
                      {/* <Checkbox
                                        checked={this.state.comment ? true : false}
                                        onChange={this.trueFalseOnChange.bind(this, "comment")}
                                        value={this.state.comment}
                                        color="primary"
                                        className="checkbox-click"
                                    /> */}
                      {/* {this.state.comment ?  */}
                      <div className="form-group margin-top-10 padding-bottom-0">
                        <input
                          type="text"
                          className="form-control"
                          maxLength={255}
                          autoComplete="off"
                          autoFocus
                          placeholder="Add Instructions"
                          onChange={this.onCommentChange.bind(this)}
                          value={this.state.attachmentnote}
                        />{" "}
                      </div>
                      {/* : ""} */}
                    </Collapse>
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.handleExpandClick06}
                    aria-expanded={!this.state.isattachment}
                  >
                    <span>
                      <FormattedMessage id="LbNo" defaultMessage="No" />
                    </span>
                    {this.state.isattachment == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  {/* 7 */}
                  <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="LbLeaveLimit"
                      defaultMessage="Comp-off leave usage limits"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    aria-expanded={this.state.maxleaveCheck}
                  >
                    <span>
                      <FormattedMessage
                        id="__LbAllowMax"
                        defaultMessage="Allow maximum of "
                      />
                      <InputValues
                        min="0"
                        max="30"
                        field="maxleave"
                        onChange={this.numberOnChange.bind(
                          this,
                          "maxleave",
                          30,
                        )}
                        value={this.state.maxleave}
                        disabled={!this.state.maxleaveCheck}
                        defaultvalue={0}
                      />
                      <FormattedMessage
                        id="__LbDaysLeave"
                        defaultMessage="day(s) leave in a  "
                      />
                      <span className="width200 inline-block">
                        <Select
                          autofocus
                          placeholder="Select"
                          options={this.state.durationSlab}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          onChange={this.durationSlabOnChange.bind(
                            this,
                            "maxdurationtypeid",
                          )}
                          value={this.state.maxdurationtypeid}
                          isDisabled={!this.state.maxleaveCheck}
                          class="width113p"
                        />
                      </span>
                    </span>
                    <span
                      onClick={this.leaveLimitHandleExpandClick07.bind(
                        this,
                        "maxleaveCheck",
                      )}
                    >
                      {this.state.maxleaveCheck == true ? (
                        <span className="floatright margin-top-10 selected-box">
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span className="not-selected-box margin-top-10" />
                      )}
                    </span>
                  </div>
                  <div
                    className="depedent-select-list"
                    aria-expanded={this.state.maxConseCheck}
                  >
                    <span>
                      <FormattedMessage
                        id="__LbAllowMaxConse"
                        defaultMessage="Allow maximum consecutive "
                      />
                      <InputValues
                        min="0"
                        max="31"
                        field="consecutiveleave"
                        onChange={this.numberOnChange.bind(
                          this,
                          "consecutiveleave",
                          31,
                        )}
                        value={this.state.consecutiveleave}
                        defaultvalue={0}
                        disabled={!this.state.maxConseCheck}
                      />
                      <FormattedMessage
                        id="__LbDaysLeave"
                        defaultMessage="day(s) leave in a  "
                      />
                      <span className="width200 inline-block">
                        <Select
                          autofocus
                          placeholder="Select"
                          options={this.state.durationSlab}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          onChange={this.durationSlabOnChange.bind(
                            this,
                            "consecutivedurationtypeid",
                          )}
                          value={this.state.consecutivedurationtypeid}
                          isDisabled={!this.state.maxConseCheck}
                          class="width113p"
                        />
                      </span>
                    </span>
                    <span
                      onClick={this.leaveLimitHandleExpandClick07.bind(
                        this,
                        "maxConseCheck",
                      )}
                    >
                      {this.state.maxConseCheck == true ? (
                        <span className="floatright margin-top-10 selected-box">
                          <svg width="24" height="24" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                          </svg>
                        </span>
                      ) : (
                        <span className="not-selected-box margin-top-10" />
                      )}
                    </span>
                  </div>
                  {this.state.error[2] ? (
                    <div className="caption-error">
                      *Please select valid value.
                    </div>
                  ) : (
                    ""
                  )}
                  {/* </div>  */}
                  {/* 8 */}

                  {/* <p className="depedent-select-list-head margin-top-30">
                    <FormattedMessage
                      id="LbHalfDay"
                      defaultMessage="Would you like to allow half-day leave applications using comp-off leaves?"
                    />
                  </p>
                  <div
                    className="depedent-select-list"
                    onClick={this.handleExpandClick08}
                    aria-expanded={this.state.allowedhalfday}
                  >
                    <span>
                      <FormattedMessage id="LbYes" defaultMessage="Yes" />
                    </span>
                    {this.state.allowedhalfday == true ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div>
                  <div
                    className="depedent-select-list "
                    onClick={this.handleExpandClick08}
                    aria-expanded={this.state.allowedhalfday == false}
                  >
                    <span>
                      <FormattedMessage id="LbNo" defaultMessage="No" />
                    </span>
                    {this.state.allowedhalfday == false ? (
                      <span className="floatright">
                        <img src={CheckImg} height="20" />
                      </span>
                    ) : (
                      <span className="not-selected" />
                    )}
                  </div> */}
                  {/* 9 */}
                  <div className="inner-wrapper opaque margin-top-20">
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbLimitFutureApplications"
                        defaultMessage="Do you want to limit leave applications for future dates?"
                      />
                    </p>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isfurtureappallowed", true)
                      }
                      aria-expanded={this.state.isfurtureappallowed == true}
                    >
                      <span>
                        {" "}
                        <FormattedMessage
                          id="LbYes"
                          defaultMessage="Yes"
                        />{" "}
                      </span>
                      {this.state.isfurtureappallowed == true ? (
                        <span className="floatright">
                          {" "}
                          <img src={CheckImg} height="20" />{" "}
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                    <div className="et-level2">
                      <Collapse
                        in={this.state.isfurtureappallowed}
                        timeout={2}
                        unmountOnExit
                        className="padding30 padding-top-20 overflow-initial"
                      >
                        <FormattedMessage
                          id="LbLeaveDurationGreater"
                          defaultMessage="If leave duration is greater than"
                        />
                        <InputValues
                          min="0"
                          max="300"
                          field="minleavecountforapp"
                          onChange={this.numberOnChange.bind(
                            this,
                            "minleavecountforapp",
                            300,
                          )}
                          value={this.state.minleavecountforapp}
                          defaultvalue={0}
                        />
                        <span>days, </span>
                        <br />
                        <FormattedMessage
                          id="__LbApplicationMustBe"
                          defaultMessage="employee must apply for a leave  atleast"
                        />
                        <InputValues
                          min="1"
                          max="365"
                          field="notifyinadvanceday"
                          onChange={this.numberOnChange.bind(
                            this,
                            "notifyinadvanceday",
                            365,
                          )}
                          value={this.state.notifyinadvanceday}
                          defaultvalue={this.state.notifyinadvanceday}
                        />
                        <span>days in advance,</span>
                        <br />
                        <FormattedMessage
                          id="__LbButNotEarlier1"
                          defaultMessage="but not earlier than"
                        />

                        <InputValues
                          min="0"
                          max="300"
                          field="notifynotbeforeday"
                          onChange={this.numberOnChange.bind(
                            this,
                            "notifynotbeforeday",
                            300,
                          )}
                          value={this.state.notifynotbeforeday}
                          defaultvalue={0}
                        />
                        <FormattedMessage id="LbDays" defaultMessage="days" />
                        <br />
                        {this.state.error[3] ? (
                          <div className="caption-error margin-top-16">
                            *Please select valid value.
                          </div>
                        ) : (
                          ""
                        )}
                      </Collapse>
                    </div>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("isfurtureappallowed", false)
                      }
                      aria-expanded={this.state.isfurtureappallowed == false}
                    >
                      <span>
                        <FormattedMessage id="LbNo" defaultMessage="No" />
                      </span>
                      {this.state.isfurtureappallowed == false ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected" />
                      )}
                    </div>
                  </div>
                  {/* 10 */}
                  <div className="inner-wrapper opaque margin-top-20">
                    <p className="depedent-select-list-head">
                      <FormattedMessage
                        id="LbPastApplications"
                        defaultMessage="Do you want to allow leave application for past dates?"
                      />
                    </p>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("ispastappallowed", true)
                      }
                      aria-expanded={this.state.ispastappallowed == true}
                    >
                      <span>
                        <FormattedMessage id="LbYes" defaultMessage="Yes" />
                      </span>
                      {this.state.ispastappallowed == true ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected " />
                      )}
                    </div>
                    <div className="et-level2">
                      <Collapse
                        in={this.state.ispastappallowed}
                        timeout={2}
                        unmountOnExit
                        className="padding30 padding-top-20 overflow-initial"
                      >
                        <FormattedMessage
                          id="LbApplMadeUpTo"
                          defaultMessage="Leave application can be made upto"
                        />
                        <InputValues
                          min="1"
                          max="45"
                          field="apppastday"
                          onChange={this.numberOnChange.bind(
                            this,
                            "apppastday",
                            45,
                          )}
                          value={this.state.apppastday}
                          defaultvalue={0}
                        />
                        <FormattedMessage
                          id="LbActualLeaveDate"
                          defaultMessage="days after actual leave date"
                        />
                        <br />
                        {this.state.error[4] ? (
                          <div className="caption-error">
                            *Please select valid value.
                          </div>
                        ) : (
                          ""
                        )}
                      </Collapse>
                    </div>
                    <div
                      className="depedent-select-list"
                      onClick={() =>
                        this.handleChange("ispastappallowed", false)
                      }
                      aria-expanded={this.state.ispastappallowed == false}
                    >
                      <span>
                        <FormattedMessage id="LbNo" defaultMessage="No" />
                      </span>
                      {this.state.ispastappallowed == false ? (
                        <span className="floatright">
                          <img src={CheckImg} height="20" />
                        </span>
                      ) : (
                        <span className="not-selected" />
                      )}
                    </div>
                  </div>
                  {/* <p className="depedent-select-list-head margin-top-30">
                                <FormattedMessage id="LbAdvancePastApplication" defaultMessage="Please choose whether leave applications must be made in advance, or can be applied for dates in the past?" />
                            </p> */}

                  {/* <div className="depedent-select-list" onClick={this.leaveApplnHandleExpandClick09.bind(this, 1)} aria-expanded={this.state.applicationmadeid == 1 ? true : false}>
                                <span>
                                    <FormattedMessage id="LbAdvanceApplication" defaultMessage="Applications must be made in advance" />
                                </span>
                                {this.state.applicationmadeid == 1 ?
                                    <span className="floatright">
                                        <img src={CheckImg} height="20" />
                                    </span>
                                    : <span className="not-selected"></span>}
                            </div>
                            <div className="et-level2">
                                <Collapse in={this.state.applicationmadeid == 1 ? true : false} timeout={2} unmountOnExit className="padding30 padding-top-5-5 overflow-initial">
                                    <ul>
                                        <li>
                                            <div  >
                                                <span>
                                                    <FormattedMessage id="LbAtleast" defaultMessage="Atleast" />
                                                </span>
                                                <span className='number-wrapper'>
                                                    <input
                                                        className="seatlimit"
                                                        type="number"
                                                        min="0"
                                                        max="500"
                                                        // allowEdit={false}
                                                        // placeholder="00"
                                                        onChange={this.numberOnChange.bind(this, "mindays", 500)}
                                                        // onBlur={this.UpdateDays.bind(this)}
                                                        // disabled={!this.state.maxConseCheck}
                                                        value={this.state.mindays}
                                                    />
                                                </span>
                                                <span >
                                                    <FormattedMessage id="LbDaysInAdvance" defaultMessage="days in advance" />
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <span >
                                                    <FormattedMessage id="LbDurationMoreThan" defaultMessage="Only if leave duration is more than" />
                                                </span>
                                                <span className='number-wrapper'>
                                                    <input
                                                        className="seatlimit"
                                                        type="number"
                                                        min="0"
                                                        max="500"
                                                        // allowEdit={false}
                                                        // placeholder="00"
                                                        onChange={this.numberOnChange.bind(this, "mindayduration", 500)}
                                                        // onBlur={this.UpdateDays.bind(this)}
                                                        // disabled={!this.state.maxConseCheck}
                                                        value={this.state.mindayduration}
                                                    />
                                                </span>
                                                <span >
                                                    <FormattedMessage id="LbDays" defaultMessage="days" />
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div  >
                                                <span>
                                                    <FormattedMessage id="LbNotMoreThan" defaultMessage="But not more than " />
                                                </span>
                                                <span className='number-wrapper'>
                                                    <input
                                                        className="seatlimit"
                                                        type="number"
                                                        min="0"
                                                        max="500"
                                                        // allowEdit={false}
                                                        // placeholder="00"
                                                        onChange={this.numberOnChange.bind(this, "maxdays", 500)}
                                                        // onBlur={this.UpdateDays.bind(this)}
                                                        // disabled={!this.state.maxConseCheck}
                                                        value={this.state.maxdays}
                                                    />
                                                </span>
                                                <span >
                                                    <FormattedMessage id="LbDaysInAdvance" defaultMessage="days in advance" />
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <span >
                                                    <FormattedMessage id="LbLessThan" defaultMessage="As long as leave duration is less than" />
                                                </span>
                                                <span className='number-wrapper'>
                                                    <input
                                                        className="seatlimit"
                                                        type="number"
                                                        min="0"
                                                        max="500"
                                                        // allowEdit={false}
                                                        // placeholder="00"
                                                        onChange={this.numberOnChange.bind(this, "maxdayduration", 500)}
                                                        // onBlur={this.UpdateDays.bind(this)}
                                                        // disabled={!this.state.maxConseCheck}
                                                        value={this.state.maxdayduration}
                                                    />
                                                </span>
                                                <span >
                                                    <FormattedMessage id="LbDays" defaultMessage="days" />
                                                </span>
                                            </div>
                                        </li>
                                    </ul>


                                </Collapse>
                            </div>
                            <div className="depedent-select-list" onClick={this.leaveApplnHandleExpandClick09.bind(this, 2)} aria-expanded={this.state.applicationmadeid == 2 ? true : false}>
                                <span>
                                    <FormattedMessage id="LbPastApplication" defaultMessage="Allow leave applications for past dates" />
                                </span>
                                {this.state.applicationmadeid == 2 ?
                                    <span className="floatright">
                                        <img src={CheckImg} height="20" />
                                    </span>
                                    : <span className="not-selected"></span>}
                            </div>
                            <div className="et-level2">
                                <Collapse in={this.state.applicationmadeid == 2 ? true : false} timeout={2} unmountOnExit className="padding30 padding-top-5-5 overflow-initial">
                                    <ul>
                                        <li>
                                            <div  >
                                                <span>
                                                    <FormattedMessage id="LbAtleast" defaultMessage="Atleast" />
                                                </span>
                                                <span className='number-wrapper'>
                                                    <input
                                                        className="seatlimit"
                                                        type="number"
                                                        min="0"
                                                        max="500"
                                                        // allowEdit={false}
                                                        // placeholder="00"
                                                        onChange={this.numberOnChange.bind(this, "pastdays", 500)}
                                                        // onBlur={this.UpdateDays.bind(this)}
                                                        // disabled={!this.state.maxConseCheck}
                                                        value={this.state.pastdays}
                                                    />
                                                </span>
                                                <span >
                                                    <FormattedMessage id="LbDaysInAdvance" defaultMessage="days in advance" />
                                                </span>
                                            </div>
                                        </li>
                                        <li>
                                            <div>
                                                <span >
                                                    <FormattedMessage id="LbDurationMoreThan" defaultMessage="Only if leave duration is more than" />
                                                </span>
                                                <span className='number-wrapper'>
                                                    <input
                                                        className="seatlimit"
                                                        type="number"
                                                        min="0"
                                                        max="500"
                                                        // allowEdit={false}
                                                        // placeholder="00"
                                                        onChange={this.numberOnChange.bind(this, "pastdayduration", 500)}
                                                        // onBlur={this.UpdateDays.bind(this)}
                                                        // disabled={!this.state.maxConseCheck}
                                                        value={this.state.pastdayduration}
                                                    />
                                                </span>
                                                <span >
                                                    <FormattedMessage id="LbDays" defaultMessage="days" />
                                                </span>
                                            </div>
                                        </li>
                                    </ul>

                                </Collapse>
                            </div> */}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

ExtraTimePolicy.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  extraTimeDataReducer: state.extraTimeDataReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      ExtraTimeData: (data) => ExtraTimeData(data),
      CommonReducerAction: (data) => CommonReducerAction(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(ExtraTimePolicy)));
